// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__BLVKj","header":"MessagesList_header__1sLGM","chat":"MessagesList_chat__2MpxH"};